import { CircularProgress, Box, Stack } from "@mui/material";
import { circularProgressClasses } from "@mui/material/CircularProgress";
import { useReactiveVar } from "@utils/reactiveVar";
import { fetchingVar } from "../../../reactiveVars/coursemanagementVars";

function MyCircularProgress() {
  return (
    <Box>
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) => theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
        }}
        size={50}
        thickness={5}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        color="primary"
        sx={{
          animationDuration: "550ms",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={50}
        thickness={5}
      />
    </Box>
  );
}

//for full screen
export const ProgressBar = () => {
  const fetching = useReactiveVar(fetchingVar);

  return (
    fetching && (
      <Stack
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 2147483640,
        }}
      >
        <Box position="absolute" top="47.5%" left="calc(50vw - 10px)" mx={-2.5} zIndex={1500}>
          <MyCircularProgress />
        </Box>
      </Stack>
    )
  );
};

export const ProgressBarLoading = ({ loading }: { loading: boolean }) => {
  if (!loading) return;
  return (
    <Stack sx={{ position: "fixed", top: 0, left: 0, height: "100%", zIndex: 1301 }}>
      <Box position="absolute" top="47.5%" left="calc(50vw - 10px)" mx={-2.5} zIndex={1001}>
        <MyCircularProgress />
      </Box>
    </Stack>
  );
};

export default ProgressBar;
